module.exports = "<div class=\"notice -error\">\n  <span class=\"title\">\n    <span class=\"icon\"></span>\n    {{ 'flash.error.title' | translate }}\n  </span>\n  <button (click)=\"dismiss()\" class=\"close\"></button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./ng2/shared/flash/flash-error/flash-error.component.html
// module id = 1196
// module chunks = 0